import BaseService from "./BaseService";
import {ROOT, ACCOUNT} from "./_base";

class BankAccountService extends BaseService {

    async getBankInfo() {
        const response = await this.postByUri(`${ROOT}/${ACCOUNT}/bank-info`);
        return response.data;
    }

    async searchBankPopup(params) {
        if(!params) params = '';
        const response = await this.postByUri(`${ROOT}/${ACCOUNT}/search-bank-popup?` + params);
        return response.data;
    }

    async searchBranchPopup(params) {
        if(!params) params = '';
        const response = await this.postByUri(`${ROOT}/${ACCOUNT}/search-branch-popup?` + params);
        return response.data;
    }


    async addBankTransfer(params) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/add-bank-transfer`, params);
        return response.data;
    }
}
export default BankAccountService